export default __webpack_public_path__ + "static/media/dots_1.83265e70.svg";